import * as React from 'react';

import { cn } from '@shared/utils/cn';

// Table Minimal : cellules 16px, séparateur en pointillés, en-tête sur fond neutre (14px semi-bold, texte secondaire)
const Table = ({
  className,
  containerClassName,
  size = 'default',
  ...props
}: React.ComponentProps<'table'> & { containerClassName?: string; size?: 'default' | 'sm' }) => (
  <div className={cn('relative w-full overflow-x-auto', containerClassName)} data-slot="table-container">
    <table
      className={cn('group/table w-full caption-bottom border-collapse text-sm', className)}
      data-size={size}
      data-slot="table"
      {...props}
    />
  </div>
);

const TableHeader = ({ className, ...props }: React.ComponentProps<'thead'>) => (
  <thead className={cn('[&_tr]:border-b-0', className)} data-slot="table-header" {...props} />
);

const TableBody = ({ className, ...props }: React.ComponentProps<'tbody'>) => (
  <tbody className={cn('[&_tr:last-child_td]:border-b-0', className)} data-slot="table-body" {...props} />
);

const TableFooter = ({ className, ...props }: React.ComponentProps<'tfoot'>) => (
  <tfoot className={cn('bg-muted font-medium [&>tr]:last:border-b-0', className)} data-slot="table-footer" {...props} />
);

const TableRow = ({ className, ...props }: React.ComponentProps<'tr'>) => (
  <tr
    className={cn(
      'transition-colors data-[state=selected]:bg-primary/5 data-[state=selected]:hover:bg-primary/10',
      className
    )}
    data-slot="table-row"
    {...props}
  />
);

const TableHead = ({ className, ...props }: React.ComponentProps<'th'>) => (
  <th
    className={cn(
      'h-14 bg-muted p-4 text-left group-data-[size=sm]/table:h-10 group-data-[size=sm]/table:py-1.5 align-middle text-sm font-semibold whitespace-nowrap text-muted-foreground first:rounded-l-lg last:rounded-r-lg',
      className
    )}
    data-slot="table-head"
    {...props}
  />
);

const TableCell = ({ className, ...props }: React.ComponentProps<'td'>) => (
  <td
    className={cn(
      'border-b border-dashed border-border p-4 align-middle text-sm group-data-[size=sm]/table:py-1.5',
      className
    )}
    data-slot="table-cell"
    {...props}
  />
);

const TableCaption = ({ className, ...props }: React.ComponentProps<'caption'>) => (
  <caption className={cn('mt-4 text-sm text-muted-foreground', className)} data-slot="table-caption" {...props} />
);

export { Table, TableRow, TableBody, TableCell, TableHead, TableHeader, TableFooter, TableCaption };
